import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=1f312caf&"
import script from "./EventHeader.vue?vue&type=script&lang=js&"
export * from "./EventHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports